.container {
  display: flex;
  align-items: center;
  gap: 1em;
}

.input {
  text-align: right;
  font-size: var(--font-size-lg);
  font-style: normal;
}

.link {
  display: inline-flex;
  gap: var(--space-sm);
  align-items: center;
  text-decoration: none;

  .number {
    font-weight: bold;
  }
}

.message {
  padding: 1rem 1.5rem;
  background-color: var(--bg-gray-darker);
  min-height: 4.5rem;
  align-content: center;
  font-size: var(--font-size-lg);
  display: inline-flex;
  gap: 0.5rem;
  align-items: center;
  width: 100%;

  &.error {
    background-color: var(--color-error-bg);
  }

  &.notify {
    background-color: var(--color-notify-bg);
  }

  &.success {
    background-color: var(--color-success-bg);
  }

  &.warning {
    background-color: var(--color-warning-bg);
  }

  &.submit {
    height: 3.625rem;
    width: inherit;
    font-size: var(--font-size-md);
    border-left: 4px solid var(--color-error-darkest);
  }

  .icon {
    padding-top: 0.375rem;
    margin-right: 0.5rem;
  }
}

.dataEntryList {
  margin-top: 2.5rem;

  details[open] {
    summary {
      display: none;
    }
  }

  summary::-webkit-details-marker {
    display: none;
  }

  summary {
    display: block;
    .pointer {
      cursor: pointer;
    }
  }
}
